import './scss/material-controller.scss'
import React, {useEffect} from "react";
import {configuratorState} from "../../state";
import {useSnapshot} from "valtio";
import FileSave from "../utils/FileSave"; // in use
import {Vector3} from "three";
import { useInRouterContext } from 'react-router-dom';

const MaterialDevControls = ({materials}) => {
  const devInaction = true;

  
  const {materialMenusReference} = useSnapshot(configuratorState);


  useEffect(() => {
    
    if (!devInaction) return;
    
    let matControlPanel;
    
    const initSetPosUi = () => {
      
      const materialControlPanel =
        
        '<div style="display: block" id="matControlPanel" class="dev-material-section">' +
          '<div class="mat-pos-header">' +
            'Modify Material Settings' +
          '</div>' +
          '<ul class="mat-output-list"> </ul>' +
          '<div class="mat-pos-save">' +
            '<span>Save</span>' +
          '</div>' +
        '</div>'
      
      document.body.insertAdjacentHTML('beforeend', materialControlPanel);
      matControlPanel = document.getElementById('matControlPanel');
      const matOutput = matControlPanel.getElementsByClassName('mat-output-list')[0];
      const saveBtn = matControlPanel.getElementsByClassName('mat-pos-save')[0];

      materialMenusReference.forEach((modelGroupMenu, modelGroupindex)=>
        {
          const modelGroupUl = document.createElement('ul');
          modelGroupUl.classList.add('model-group');
          modelGroupUl.innerText = modelGroupMenu.title;
          modelGroupMenu.menu.forEach((matGroupMenu, matGroupindex)=>
            {
              const matGroupUl = document.createElement('ul');
              matGroupUl.classList.add('mat-group');
              matGroupUl.innerText = matGroupMenu.title;
              matGroupMenu.menu.forEach((matMenu, matindex)=>
                {
                  const matUl = document.createElement('ul');
                  matUl.classList.add('matetial');
                  matUl.innerText = matMenu.title;
                  Object.keys(matMenu.materialProps).forEach(matKey=>
                    {
                      let matProp = matMenu.materialProps[matKey];
                      const matPropLi = document.createElement('li');
                      const input = document.createElement('input');
                      const label = document.createElement('label');
                      label.innerText = matKey;
                      if(typeof(matProp) === 'number')
                      {
                        input.type = "range";
                        input.min = 0;
                        input.max = 1;
                        input.step = 0.01;
                        input.value = matProp;
                        input.addEventListener('input',function(evt)
                        {
                          configuratorState.materialMenusReference[modelGroupindex]['menu'][matGroupindex]['menu'][matindex]['materialProps'][matKey] = evt.target.value;
                        });
                      }
                      else if(matKey === 'color')
                      {
                        input.type = "color";
                        input.value = matProp;
                        input.addEventListener('input',function(evt)
                        {
                          configuratorState.materialMenusReference[modelGroupindex]['menu'][matGroupindex]['menu'][matindex]['materialProps'][matKey] = evt.target.value.replace('#','0x');
                        });
                      }
                      else if(matKey === "wrap")
                      {
                        return;
                      }
                      matPropLi.appendChild(label);
                      matPropLi.appendChild(input);
                      matUl.appendChild(matPropLi);
                    })
                  matGroupUl.appendChild(matUl);
                });
                modelGroupUl.appendChild(matGroupUl);
            });
            matOutput.appendChild(modelGroupUl);
        });
      
      saveBtn.addEventListener('click', function () {
        
        if (!matOutput.lastChild) return;
        
        let myFile = new File(
          [JSON.stringify(materialMenusReference)],
          "main-material-sets.json",
          {type: "text/plane;charset=utf8"}
        );
        saveAs(myFile);
      });
      
    }
    
    let displayInAction = false;
    
    // in action - use ( Alt + m )
    window.addEventListener('keydown', function (event) {
      
      if (event.altKey && event.keyCode === 77) {
        
        if (!displayInAction) {
          
          initSetPosUi();
          displayInAction = true;
          
        } else {
          
          matControlPanel.remove();
          displayInAction = false;
          
        }
      }
    });
    
  }, []);
  
}

export default MaterialDevControls;
